import type { ApplicationRecord } from '../types/domain'

export const internationalApplications: ApplicationRecord[] = [
  {
    id: 'app-9',
    ref: 'SDU-INT-2026-118',
    eventName: 'Abu Dhabi Festival of Classical Arts 2026',
    entityId: 'en-1',
    track: 'international',
    hostBody: 'Self-organised',
    emirate: 'Abu Dhabi',
    sector: 'Culture',
    requestedSupportAed: 3_200_000,
    editionYear: 2026,
    stage: 'outreach',
    status: 'active',
    stageEnteredOn: '2026-07-02',
    daysInStage: 47,
    slaDueOn: '2026-11-20',
    officer: 'Noura Al Kaabi',
    aiScore: 86.4,
    summary:
      'Approved against SDU international event standards and running on a Gold outreach package across the culture and tourism ecosystem.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 92, evidence: 'All licensing, safety and accessibility standards evidenced.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 84, evidence: '46% overseas attendance in the 2025 edition.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 88, evidence: 'Strong fit with cultural diplomacy positioning.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 79, evidence: 'Full asset library delivered; Arabic creative delivered late.' }
    ],
    flags: [],
    recommendations: [
      { id: 're-15', ruleId: 'rr-9', title: 'Reallocate inventory from embassy network to airline channels', detail: 'Embassy placements at 64% of guarantee at mid-campaign while airline inflight channels are over-delivering.', confidence: 85, stage: 'outreach', status: 'pending' }
    ],
    documents: [
      { id: 'do-33', label: 'Event licence and permits', status: 'verified', updatedOn: '2026-06-18' },
      { id: 'do-34', label: 'Brand and creative asset pack', status: 'verified', updatedOn: '2026-06-25' },
      { id: 'do-35', label: 'Arabic creative adaptation', status: 'verified', updatedOn: '2026-07-09' }
    ],
    timeline: [
      { id: 'tl-32', on: '2026-05-20', actor: 'Noura Al Kaabi', label: 'Application received' },
      { id: 'tl-33', on: '2026-06-02', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 86.4 — auto-advance band.' },
      { id: 'tl-34', on: '2026-06-28', actor: 'Hend AlMheiri', label: 'Approved against standards' },
      { id: 'tl-35', on: '2026-07-02', actor: 'Noura Al Kaabi', label: 'Gold package activated' }
    ],
    gates: {
      assessment: [
        { id: 'g-66', label: 'Standards compliance verified', kind: 'artefact', status: 'met', owner: 'SDU Standards' },
        { id: 'g-67', label: 'Creative asset pack received', kind: 'artefact', status: 'met', owner: 'DCT Abu Dhabi' }
      ],
      approval: [
        { id: 'g-68', label: 'Package tier agreed and invoiced', kind: 'artefact', status: 'met', owner: 'SDU Commercial' },
        { id: 'g-69', label: 'Outreach manager sign-off', kind: 'signoff', status: 'met', owner: 'Noura Al Kaabi' }
      ],
      outreach: [
        { id: 'g-70', label: 'All placements scheduled', kind: 'artefact', status: 'met', owner: 'SDU Outreach' },
        { id: 'g-71', label: 'Impression guarantee on track', kind: 'artefact', status: 'partial', owner: 'SDU Outreach', note: 'Embassy network at 64% of guarantee.' },
        { id: 'g-72', label: 'Post-campaign report issued', kind: 'signoff', status: 'outstanding', owner: 'Noura Al Kaabi' }
      ]
    },
    outreachId: 'oc-1'
  },
  {
    id: 'app-10',
    ref: 'SDU-INT-2026-104',
    eventName: 'Dubai Esports & Games Festival 2026',
    entityId: 'en-2',
    track: 'international',
    hostBody: 'Self-organised',
    emirate: 'Dubai',
    sector: 'Digital Economy',
    requestedSupportAed: 6_400_000,
    editionYear: 2026,
    stage: 'outreach',
    status: 'active',
    stageEnteredOn: '2026-06-10',
    daysInStage: 69,
    slaDueOn: '2026-10-01',
    officer: 'Noura Al Kaabi',
    aiScore: 91.2,
    summary:
      'Platinum package with full ecosystem activation including airline, embassy and official social network distribution.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 94, evidence: 'Third consecutive edition with no compliance findings.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 93, evidence: '58% overseas attendance and 4.1M livestream viewers.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 87, evidence: 'Direct fit with digital economy positioning.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 90, evidence: 'In-house studio delivering assets four weeks ahead.' }
    ],
    flags: [],
    recommendations: [],
    documents: [
      { id: 'do-36', label: 'Event licence and permits', status: 'verified', updatedOn: '2026-05-14' },
      { id: 'do-37', label: 'Brand and creative asset pack', status: 'verified', updatedOn: '2026-05-20' }
    ],
    timeline: [
      { id: 'tl-36', on: '2026-04-28', actor: 'Noura Al Kaabi', label: 'Application received' },
      { id: 'tl-37', on: '2026-05-06', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 91.2 — auto-advance band.' },
      { id: 'tl-38', on: '2026-06-04', actor: 'Hend AlMheiri', label: 'Approved against standards' },
      { id: 'tl-39', on: '2026-06-10', actor: 'Noura Al Kaabi', label: 'Platinum package activated' }
    ],
    gates: {
      assessment: [
        { id: 'g-73', label: 'Standards compliance verified', kind: 'artefact', status: 'met', owner: 'SDU Standards' },
        { id: 'g-74', label: 'Creative asset pack received', kind: 'artefact', status: 'met', owner: 'DWTC' }
      ],
      approval: [
        { id: 'g-75', label: 'Package tier agreed and invoiced', kind: 'artefact', status: 'met', owner: 'SDU Commercial' },
        { id: 'g-76', label: 'Outreach manager sign-off', kind: 'signoff', status: 'met', owner: 'Noura Al Kaabi' }
      ],
      outreach: [
        { id: 'g-77', label: 'All placements scheduled', kind: 'artefact', status: 'met', owner: 'SDU Outreach' },
        { id: 'g-78', label: 'Impression guarantee on track', kind: 'artefact', status: 'met', owner: 'SDU Outreach' },
        { id: 'g-79', label: 'Post-campaign report issued', kind: 'signoff', status: 'outstanding', owner: 'Noura Al Kaabi' }
      ]
    },
    outreachId: 'oc-2'
  },
  {
    id: 'app-11',
    ref: 'SDU-INT-2026-131',
    eventName: 'Sharjah International Book Fair — World Edition',
    entityId: 'en-5',
    track: 'international',
    hostBody: 'Self-organised',
    emirate: 'Sharjah',
    sector: 'Culture',
    requestedSupportAed: 2_100_000,
    editionYear: 2026,
    stage: 'approval',
    status: 'in-review',
    stageEnteredOn: '2026-08-11',
    daysInStage: 7,
    slaDueOn: '2026-08-25',
    officer: 'Noura Al Kaabi',
    aiScore: 82.7,
    summary:
      'Cleared standards assessment; awaiting package tier confirmation and outreach manager sign-off before distribution begins.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 89, evidence: 'Long-running event with full compliance history.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 81, evidence: '38% overseas exhibitor participation.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 85, evidence: 'Strong publishing and knowledge economy fit.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 73, evidence: 'Assets available but no English-language video package.' }
    ],
    flags: [
      { id: 'fl-15', severity: 'medium', label: 'Video asset package incomplete', detail: 'No English-language video assets for airline inflight and social channels.' }
    ],
    recommendations: [
      { id: 're-16', ruleId: 'rr-10', title: 'Propose a Gold tier upgrade with embassy network activation', detail: 'Overseas participation share supports wider international distribution than the requested Silver tier.', confidence: 64, stage: 'approval', status: 'pending' }
    ],
    documents: [
      { id: 'do-38', label: 'Event licence and permits', status: 'verified', updatedOn: '2026-08-01' },
      { id: 'do-39', label: 'Brand and creative asset pack', status: 'uploaded', updatedOn: '2026-08-09' },
      { id: 'do-40', label: 'English-language video package', status: 'missing', updatedOn: '2026-08-09' }
    ],
    timeline: [
      { id: 'tl-40', on: '2026-07-24', actor: 'Noura Al Kaabi', label: 'Application received' },
      { id: 'tl-41', on: '2026-08-02', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 82.7 — auto-advance band.' },
      { id: 'tl-42', on: '2026-08-11', actor: 'Noura Al Kaabi', label: 'Advanced to Approval' }
    ],
    gates: {
      assessment: [
        { id: 'g-80', label: 'Standards compliance verified', kind: 'artefact', status: 'met', owner: 'SDU Standards' },
        { id: 'g-81', label: 'Creative asset pack received', kind: 'artefact', status: 'partial', owner: 'Shurooq', note: 'Video package outstanding.' }
      ],
      approval: [
        { id: 'g-82', label: 'Package tier agreed and invoiced', kind: 'artefact', status: 'outstanding', owner: 'SDU Commercial' },
        { id: 'g-83', label: 'Outreach manager sign-off', kind: 'signoff', status: 'outstanding', owner: 'Noura Al Kaabi' }
      ]
    }
  },
  {
    id: 'app-12',
    ref: 'SDU-INT-2026-140',
    eventName: 'Ras Al Khaimah Half Marathon 2027',
    entityId: 'en-6',
    track: 'international',
    hostBody: 'World Athletics',
    emirate: 'Ras Al Khaimah',
    sector: 'Sport',
    requestedSupportAed: 1_450_000,
    editionYear: 2027,
    stage: 'assessment',
    status: 'in-review',
    stageEnteredOn: '2026-08-13',
    daysInStage: 5,
    slaDueOn: '2026-09-06',
    officer: 'Fatima Al Hosani',
    aiScore: 77.5,
    summary:
      'World Athletics elite label event seeking amplification support for the 2027 edition.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 86, evidence: 'World Athletics elite label maintained since 2019.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 74, evidence: '31% overseas participation across 74 nationalities.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 76, evidence: 'Fits active lifestyle and northern emirates tourism positioning.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 71, evidence: 'Lead time adequate; social channels under-scaled.' }
    ],
    flags: [
      { id: 'fl-16', severity: 'medium', label: 'Organiser channel scale limited', detail: 'Owned social reach below the level assumed by Silver tier modelling.' }
    ],
    recommendations: [
      { id: 're-17', ruleId: 'rr-9', title: 'Weight the package toward ecosystem partner channels', detail: 'Organiser-owned channels cannot carry the guarantee; partner inventory should carry 80% of impressions.', confidence: 76, stage: 'assessment', status: 'pending' }
    ],
    documents: [
      { id: 'do-41', label: 'Event licence and permits', status: 'uploaded', updatedOn: '2026-08-13' },
      { id: 'do-42', label: 'World Athletics label certificate', status: 'verified', updatedOn: '2026-08-13' },
      { id: 'do-43', label: 'Brand and creative asset pack', status: 'missing', updatedOn: '2026-08-13' }
    ],
    timeline: [
      { id: 'tl-43', on: '2026-08-13', actor: 'Fatima Al Hosani', label: 'Application received' },
      { id: 'tl-44', on: '2026-08-15', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 77.5 — auto-advance band.' }
    ],
    gates: {
      assessment: [
        { id: 'g-84', label: 'Standards compliance verified', kind: 'artefact', status: 'partial', owner: 'SDU Standards', note: 'Permits uploaded, verification pending.' },
        { id: 'g-85', label: 'Creative asset pack received', kind: 'artefact', status: 'outstanding', owner: 'RAKTDA' }
      ]
    }
  },
  {
    id: 'app-13',
    ref: 'SDU-INT-2026-097',
    eventName: 'Ajman Heritage Days 2026',
    entityId: 'en-9',
    track: 'international',
    hostBody: 'Self-organised',
    emirate: 'Ajman',
    sector: 'Culture',
    requestedSupportAed: 620_000,
    editionYear: 2026,
    stage: 'outreach',
    status: 'active',
    stageEnteredOn: '2026-07-25',
    daysInStage: 24,
    slaDueOn: '2026-10-10',
    officer: 'Noura Al Kaabi',
    aiScore: 74.8,
    summary:
      'Silver package running across government portals and tourism board channels, with regional social distribution.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 82, evidence: 'Standards met with one advisory on crowd management.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 62, evidence: '19% overseas attendance, mostly GCC residents.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 84, evidence: 'Strong heritage and national identity fit.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 70, evidence: 'Assets adequate for regional distribution only.' }
    ],
    flags: [
      { id: 'fl-17', severity: 'medium', label: 'Tourism board channel under-delivering', detail: 'Tourism board placements at 58% of guaranteed impressions at week 3.' }
    ],
    recommendations: [
      { id: 're-18', ruleId: 'rr-9', title: 'Reallocate inventory to government portal channels', detail: 'Portal placements are over-delivering by 22% and can absorb the shortfall.', confidence: 81, stage: 'outreach', status: 'pending' }
    ],
    documents: [
      { id: 'do-44', label: 'Event licence and permits', status: 'verified', updatedOn: '2026-07-10' },
      { id: 'do-45', label: 'Brand and creative asset pack', status: 'verified', updatedOn: '2026-07-18' }
    ],
    timeline: [
      { id: 'tl-45', on: '2026-06-22', actor: 'Noura Al Kaabi', label: 'Application received' },
      { id: 'tl-46', on: '2026-07-01', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 74.8 — auto-advance band.' },
      { id: 'tl-47', on: '2026-07-21', actor: 'Hend AlMheiri', label: 'Approved against standards' },
      { id: 'tl-48', on: '2026-07-25', actor: 'Noura Al Kaabi', label: 'Silver package activated' }
    ],
    gates: {
      assessment: [
        { id: 'g-86', label: 'Standards compliance verified', kind: 'artefact', status: 'met', owner: 'SDU Standards' },
        { id: 'g-87', label: 'Creative asset pack received', kind: 'artefact', status: 'met', owner: 'Ajman Chamber' }
      ],
      approval: [
        { id: 'g-88', label: 'Package tier agreed and invoiced', kind: 'artefact', status: 'met', owner: 'SDU Commercial' },
        { id: 'g-89', label: 'Outreach manager sign-off', kind: 'signoff', status: 'met', owner: 'Noura Al Kaabi' }
      ],
      outreach: [
        { id: 'g-90', label: 'All placements scheduled', kind: 'artefact', status: 'met', owner: 'SDU Outreach' },
        { id: 'g-91', label: 'Impression guarantee on track', kind: 'artefact', status: 'outstanding', owner: 'SDU Outreach', note: 'Tourism board channel at 58% of guarantee.' },
        { id: 'g-92', label: 'Post-campaign report issued', kind: 'signoff', status: 'outstanding', owner: 'Noura Al Kaabi' }
      ]
    },
    outreachId: 'oc-3'
  },
  {
    id: 'app-14',
    ref: 'SDU-INT-2026-088',
    eventName: 'Fujairah Watersports Week 2026',
    entityId: 'en-10',
    track: 'international',
    hostBody: 'Self-organised',
    emirate: 'Fujairah',
    sector: 'Sport',
    requestedSupportAed: 480_000,
    editionYear: 2026,
    stage: 'assessment',
    status: 'rejected',
    stageEnteredOn: '2026-06-30',
    daysInStage: 49,
    slaDueOn: '2026-07-28',
    officer: 'Fatima Al Hosani',
    aiScore: 48.2,
    summary:
      'Declined at Assessment. Entity is under restricted compliance standing and safety standards for open-water events were not evidenced.',
    criteria: [
      { id: 'standards', label: 'Event standards compliance', weight: 30, score: 38, evidence: 'Open-water safety plan and marine permits not submitted.' },
      { id: 'audience', label: 'International audience draw', weight: 25, score: 44, evidence: '8% overseas attendance in the previous edition.' },
      { id: 'brand', label: 'Brand alignment with UAE narrative', weight: 25, score: 66, evidence: 'Reasonable fit with east coast tourism positioning.' },
      { id: 'readiness', label: 'Organiser marketing readiness', weight: 20, score: 42, evidence: 'No creative assets or channel plan submitted.' }
    ],
    flags: [
      { id: 'fl-18', severity: 'critical', label: 'Safety standards not evidenced', detail: 'Marine safety plan and coastguard coordination letter missing.' },
      { id: 'fl-19', severity: 'high', label: 'Entity compliance restricted', detail: 'Restricted standing following unresolved findings from the 2024 edition.' }
    ],
    recommendations: [
      { id: 're-19', ruleId: 'rr-1', title: 'Decline and invite resubmission after compliance remediation', detail: 'Weighted score in the decline band with a critical safety gap.', confidence: 93, stage: 'assessment', status: 'accepted' }
    ],
    documents: [
      { id: 'do-46', label: 'Application form and event concept', status: 'verified', updatedOn: '2026-06-30' },
      { id: 'do-47', label: 'Marine safety plan', status: 'missing', updatedOn: '2026-07-12' },
      { id: 'do-48', label: 'Brand and creative asset pack', status: 'missing', updatedOn: '2026-07-12' }
    ],
    timeline: [
      { id: 'tl-49', on: '2026-06-30', actor: 'Fatima Al Hosani', label: 'Application received' },
      { id: 'tl-50', on: '2026-07-05', actor: 'AI Assessment Engine', label: 'Standards score generated', detail: 'Weighted score 48.2 — decline band.' },
      { id: 'tl-51', on: '2026-07-28', actor: 'Hend AlMheiri', label: 'Application declined', detail: 'Safety standards not evidenced; entity invited to resubmit after remediation.' }
    ],
    gates: {
      assessment: [
        { id: 'g-93', label: 'Standards compliance verified', kind: 'artefact', status: 'outstanding', owner: 'SDU Standards' },
        { id: 'g-94', label: 'Creative asset pack received', kind: 'artefact', status: 'outstanding', owner: 'Fujairah Culture & Media' }
      ]
    }
  }
]
